import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NotifierService } from '../services/notifier-service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  //#region Inputs, Outputs, ViewChilds
  //#endregion Inputs, Outputs, ViewChilds

  //#region Public Variables
  //#endregion Public Variables

  //#region Private Variables
 // private authenticationService: AuthenticationService;
  //#endregion Private Variables

  //#region Properties
  //#endregion Properties

  //#region Constructor and Angular Life Cycle
  constructor(private notifierService: NotifierService, private injector: Injector) {
  }
  //#endregion Constructor and Angular Life Cycle

  //#region Event Handlers
  //#endregion Event Handlers

  //#region Public Methods
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public handleError(err: any): void {
    let displaySnack: boolean = false;
    let errorMsg: string = null;
    let message: string = null;
    let rethrowException: boolean = false;
    let stackTrace: string = null;

    if (err instanceof TypeError) {
      message = 'A type error ocurred!';
      errorMsg = this.getMessageFromTypeError(err);
      stackTrace = this.stackTraceFromTypeError(err);
      displaySnack = false;
      rethrowException = true;
    } else if (err.error instanceof ErrorEvent) {
      message = 'An event error ocurred!';
      errorMsg = this.getMessageFromErrorEvent(err);
    } else if (err instanceof HttpErrorResponse) {
      message = this.formatHttpErrorMessage(err);
      errorMsg = this.getMessageFromHttpError(err);
    } else if (err instanceof Error) {
      message = 'An error ocurred!';
      errorMsg = this.getMessageFromError(err);
      stackTrace = this.stackTraceFromError(err);
    } else {
      message = 'An unhandled error ocurred!';
      errorMsg = this.getMessageFromUnknownErrType(err);
    }

    console.error(errorMsg);
    if (stackTrace) {
      console.error(stackTrace);
    }
    if (displaySnack) {
      this.notifierService.DisplayErrorMessage(message);
    }
    if (rethrowException) {
      throw err;
    }
  }
  //#endregion Public Methods

  //#region Private Methods
  private formatHttpErrorMessage(err: HttpErrorResponse): string {
    if (err.status === 401) {
        return `[${err.status} Unauthorized]: You are not authorized to view this page!`;
    }

    return err.error.ErrorMessage ? err.error.ErrorMessage : `[HTTP ${err.status}] An HTTP error ocurred!`;
  }

  private getMessageFromError(err: Error): string {
    return err.message ? err.message : err.toString();
  }

  private getMessageFromErrorEvent(err: ErrorEvent): string {
    return err.message;
  }

  private getMessageFromHttpError(err: HttpErrorResponse): string {
    return err.message;
  }

  private getMessageFromTypeError(err: TypeError): string {
    return err.message;
  }

  private getMessageFromUnknownErrType(err: any): string {
    return `An unknown type error occurred: ${err}`;
  }

  private stackTraceFromError(err: Error): string {
    return err.stack;
  }

  private stackTraceFromTypeError(err: Error): string {
    return err.stack;
  }

  //#endregion Private Methods
}
